import Div from "@jumbo/shared/Div";
import { Form, Formik } from "formik";
import * as yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";
import React from "react";
import { Button, Typography } from "@mui/material";
import FormTextField from "app/components/InputField/FormTextField";
import { updateUnit } from "app/services/apis/updateUnit";
import Swal from "sweetalert2";
import { addUnit } from "app/services/apis/addUnit";
import { useState } from "react";
import { LoadingButton } from "@mui/lab";

export default function AddUnit() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { state } = useLocation();
  const [isSubmitting, setSubmitting] = useState(false);
  const units = {
    unit_name: state?.unit_name ? state?.unit_name : "",
  };
  const validationSchema = yup.object({
    unit_name: yup.string("Enter Unit Name").required("Unit Name is required"),
  });
  const onUserSave = async (values) => {
    // console.log({ ...values });
    setSubmitting(true);
    if (pathname == "/master/unit/edit") {
      const data = await updateUnit(values, state.id);
      if (data?.status == 200) {
        Swal.fire({
          icon: "success",
          title: "Unit Edited Successfully",
          text: "",
        });
        navigate("/dashboard/master/unit");
      } else {
        Swal.fire({
          icon: "error",
          title: data?.message,
          text: "",
        });
      }
    } else {
      const data = await addUnit(values);
      if (data?.status == 200) {
        Swal.fire({
          icon: "success",
          title: "Unit Added Successfully",
          text: "",
        });
        navigate("/dashboard/master/unit");
      } else {
        Swal.fire({
          icon: "error",
          title: data?.data?.message,
          text: "",
        });
      }
    }
    setSubmitting(false);
  };
  return (
    <Div sx={{ mt: -4 }}>
      <Typography variant="h1">
        {pathname == "/master/unit/add" ? "Add New Unit" : "Edit Unit"}
      </Typography>
      <Div>
        <Formik
          validateOnChange={true}
          initialValues={units}
          enableReinitialize={true}
          validationSchema={validationSchema}
          onSubmit={onUserSave}
        >
          {({ values }) => (
            <Form noValidate autoComplete="off">
              <Div sx={{ mt: 4 }}>
                <Div
                  sx={{
                    display: "flex",
                    width: "100%",
                    flexWrap: "wrap",
                    columnGap: 5,
                  }}
                >
                  <FormTextField name="unit_name" label="Unit Name" />
                </Div>
                <Div
                  sx={{
                    width: "93.5%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 3,
                    mt: 3,
                  }}
                >
                  <Button
                    variant="outlined"
                    onClick={() => {
                      Swal.fire({
                        title: "Are you sure you want to cancel?",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonText: "Yes",
                        cancelButtonText: "No",
                      }).then((result) => {
                        if (result.isConfirmed) {
                          navigate("/dashboard/master/unit");
                        }
                      });
                    }}
                  >
                    Cancel
                  </Button>

                  <LoadingButton
                    variant="contained"
                    type="submit"
                    sx={{ width: "100px" }}
                    loading={isSubmitting}
                  >
                    Save
                  </LoadingButton>
                </Div>
              </Div>
            </Form>
          )}
        </Formik>
      </Div>
    </Div>
  );
}
